import type { FC, ReactElement } from "react"

import isEmpty from "lodash-es/isEmpty"

import {
    ETypographyAlignment,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { type IUseTranslation, useTranslation } from "@/hooks"

const Title: FC = (): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    const { data: productType }: TProductTypeQuery = useProductTypeQuery()

    return (
        <Typography
            text={
                isEmpty(productType?.coachingSessionsPageName)
                    ? t("participantSide.sessionsPage.title")
                    : productType?.coachingSessionsPageName
            }
            tag={ETypographyTag.Heading1}
            alignment={ETypographyAlignment.Center}
            weight={ETypographyWeight.Medium}
            size={ETypographySize.Heading1}
            family={ETypographyFamily.DmSerif}
        />
    )
}

Title.displayName = "ParticipantCoachingSessionsTitle"

export { Title as ParticipantCoachingSessionsTitle }
